import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DesignatedUnitGeneralDetailsFormGroup } from '../../../../../employers/add-employer/forms/designated-unit-general-details-form-group';

@Component({
  selector: 'app-create-designated-unit-general-details-effective-period-section',
  templateUrl: './designated-unit-effective-period-section.component.html',
  styleUrls: ['./designated-unit-effective-period-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitGeneralDetailsEffectivePeriodSectionComponent {
  @Input() formGroup!: DesignatedUnitGeneralDetailsFormGroup;
  @Input() formSubmitted: boolean = false;

  public customErrorMessages = {
    startDate: {
      required: $localize`Effective Start Date required`
    },
    endDate: {
      dateRangeInvalid: $localize`Expiry Date must be after Effective Start Date`,
      endDateRequiredWhenBackdated: $localize`Expiry Date is required when the Effective Start Date is in the past`
    }
  };
}
